import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import TransactionHeader from 'modules/budget/components/budget-table/transaction-header';
import TransactionItem from 'modules/budget/components/budget-table/transaction-item';

@withNamespaces()
@inject('store')
@observer
class TransactionSubtable extends Component {
    componentDidMount() {
        this.props.category.requestTransactions();
    }

    render() {
        const COLSPAN = 5;
        const { t, transactions } = this.props;
        const { loading } = this.props.category;
        const { isMobile } = this.props.store.app;

        if (loading) {
            return (
                <tr>
                    <td colSpan={isMobile ? COLSPAN + 1 : COLSPAN}>
                        <div className="progress">
                            <div className="progress-bar-indeterminate" />
                        </div>
                    </td>
                </tr>
            );
        }

        if (transactions.length === 0) {
            return (
                <tr className="row-details">
                    <td colSpan={isMobile ? COLSPAN + 1 : COLSPAN} className="text-muted font-italic">
                        {t('BUDGET.TABLE.NO_TRANSACTIONS')}
                    </td>
                </tr>

            );
        }

        return (
            <Fragment>
                <TransactionHeader isMobile={isMobile} />
                {transactions.map(transaction => <TransactionItem key={transaction.id} transaction={transaction} />)}
                <tr className="row-details-divider">
                    <td colSpan={isMobile ? COLSPAN + 1 : COLSPAN} />
                </tr>
            </Fragment>
        );
    }
}

TransactionSubtable.propTypes = {
    /** Array of TransactionItem from store belonging to some category */
    transactions: PropTypes.array.isRequired,

    /** Category to which this subtable belongs */
    category: PropTypes.any.isRequired,
};

export default TransactionSubtable;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/transaction-subtable.js